import { modules } from "component/molecules/viewport/toolStates/store.js";
//import getActiveToolsForElement from "component/molecules/viewport/store/getActiveToolsForElement.js";
import getActiveToolsForElement from "component/molecules/viewport/toolStates/getActiveToolsForElement.js";
import { getToolState, addToolState } from "component/toolManager/toolState.js";
import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool.js";
import { getNewContext } from "component/molecules/viewport/draw/index.js";
import {
  resetCanvasContextTransform,
  transformCanvasContext
} from "component/molecules/viewport/draw/index.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import math from "core/math";
import { getColormap } from "core/color/colormap.js";
import storedPixelDataToCanvasImageDataColorLUT from "core/canvas/storedPixelDataToCanvasImageDataColorLUT.js";

const store = {
  modules
};
const { state, setters, getters } = store.modules.brush;
/* Safari and Edge polyfill for createImageBitmap
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/createImageBitmap
 */
// https://babeljs.io/docs/en/babel-plugin-transform-runtime

function makeImageId(elementId, imageSOPUID) {
  const imageId = elementId + "_" + imageSOPUID;
  return imageId;
}

if (!("createImageBitmap" in window)) {
  window.createImageBitmap = async function(imageData) {
    return new Promise(resolve => {
      const img = document.createElement("img");

      img.addEventListener("load", function() {
        resolve(this);
      });

      const conversionCanvas = document.createElement("canvas");

      conversionCanvas.width = imageData.width;
      conversionCanvas.height = imageData.height;

      const conversionCanvasContext = conversionCanvas.getContext("2d");

      conversionCanvasContext.putImageData(
        imageData,
        0,
        0,
        0,
        0,
        conversionCanvas.width,
        conversionCanvas.height
      );
      img.src = conversionCanvas.toDataURL();
    });
  };
}

/**
 * Used to redraw the brush label map data per render.
 *
 * @private
 * @param {Object} evt - The event.
 */
export default function(evt) {
  const eventData = evt.detail;
  const element = eventData.element;
  //const maxSegmentations = BaseBrushTool.getNumberOfColors();
  const maxSegmentations = 1;
  let toolData = getToolState(
    element,
    BaseBrushTool.getReferencedToolDataName()
  );

  if (!toolData) {
    // Make toolData array as big as max number of segmentations.
    for (let i = 0; i < maxSegmentations; i++) {
      addToolState(element, BaseBrushTool.getReferencedToolDataName(), {});
    }

    toolData = getToolState(element, BaseBrushTool.getReferencedToolDataName());

    // TEMP: HACK: Create first pixel data such that the tool has some data and the brush
    // Cursor can be rendered. Can be replaced once we have a mechanism for SVG cursors.
    const newPixelData = new Uint8ClampedArray(
      eventData.image.width * eventData.image.height
    );

    toolData.data[0].pixelData = newPixelData;

    toolData = getToolState(element, BaseBrushTool.getReferencedToolDataName());
  }

  const enabledElement = getEnabledElement(element);
  const enabledElementUID = enabledElement.uuid;
  const id = makeImageId(enabledElementUID, eventData.image.sopInstanceUID);

  const test = getters.visibleSegmentationsForElement(
    //enabledElementUID
    id
  );
  if (test === null) {
    setters.elementVisible(element);
  }

  const segData = {
    visibleSegmentations: getters.visibleSegmentationsForElement(
      //enabledElementUID
      id
    ),
    //imageBitmapCache: getters.imageBitmapCacheForElement(enabledElementUID),
    imageBitmapCache: getters.imageBitmapCacheForElement(id),
    toolData
  };

  for (let segIndex = 0; segIndex < maxSegmentations; segIndex++) {
    if (shouldRenderSegmentation(evt, segIndex, segData)) {
      renderSegmentation(evt, segIndex, segData);
    }
  }
}

function shouldRenderSegmentation(evt, segIndex, segData) {
  const element = evt.detail.element;
  const toolData = segData.toolData;
  const visibleSegmentations = segData.visibleSegmentations;

  if (!toolData.data[segIndex] || !toolData.data[segIndex].pixelData) {
    // No data, no render.
    return false;
  }

  if (visibleSegmentations[segIndex]) {
    // Has data and marked as visible, render!
    return true;
  }

  const currentColor = state.drawColorId;

  if (currentColor !== segIndex) {
    // Hidden and not current color, don't render.
    return false;
  }

  // Check that a brush tool is active.
  const activeTools = getActiveToolsForElement(element, store.state.tools);
  const brushTools = activeTools.filter(tool => tool instanceof BaseBrushTool);

  if (brushTools.length > 0) {
    // Active brush tool with same color, render!
    return true;
  }

  return false;
}

function renderSegmentation(evt, segIndex, segData) {
  const toolData = segData.toolData;
  const imageBitmapCache = segData.imageBitmapCache;
  const visibleSegmentations = segData.visibleSegmentations;

  // Draw previous image if cached.
  if (imageBitmapCache && imageBitmapCache[segIndex]) {
    _drawImageBitmap(
      evt,
      imageBitmapCache[segIndex],
      visibleSegmentations[segIndex]
    );
  }

  if (toolData.data[segIndex].invalidated) {
    createNewBitmapAndQueueRenderOfSegmentation(evt, toolData, segIndex);
  }
}

var tempEnabledElement = null;
var tempElement = null;

function createNewBitmapAndQueueRenderOfSegmentation(evt, toolData, segIndex) {
  const eventData = evt.detail;
  const element = eventData.element;
  var enabledElement = getEnabledElement(element);

  const pixelData = toolData.data[segIndex].pixelData;
  const isActive = state.isActive;
  if (!pixelData) {
    return;
  }

  // 분할 영역 드로잉
  const colormapId = state.colorMapId;
  const colormap = getColormap(colormapId);
  let colorLutTable = getters.transparentColorSet();

  if (state.isActive) {
    colorLutTable = getters.useColorSet();
  } else {
    colorLutTable = getters.transparentColorSet(6);
  }

  const imageData = new ImageData(
    eventData.image.width,
    eventData.image.height
  );
  const image = {
    stats: {},
    minPixelValue: 0,
    getPixelData: () => pixelData
  };

  storedPixelDataToCanvasImageDataColorLUT(
    image,
    colorLutTable,
    imageData.data
  );
  tempEnabledElement = enabledElement;
  tempElement = element;
  if (tempEnabledElement === null)
  {
  }
  const localEnabledElement = enabledElement;
  const localEventData = eventData;

window.createImageBitmap(imageData).then(function(newImageBitmap) {
  if (!localEnabledElement || !localEnabledElement.uuid) {
    console.warn("🚨 localEnabledElement is null in createImageBitmap.then");
    return;
  }

  const id = makeImageId(
    localEnabledElement.uuid,
    localEventData.image.sopInstanceUID
  );

  setters.elementVisible(localEventData.element);
  setters.imageBitmapCacheForElement(id, segIndex, newImageBitmap);
  toolData.data[segIndex].invalidated = false;

  const updatedElement = getEnabledElement(localEnabledElement.element);
  if (updatedElement) updatedElement.needsRedraw = true;
});
}

/**
 * Draws the ImageBitmap the canvas.
 *
 * @private
 * @param  {Object} evt description
 */
function _drawImageBitmap(evt, imageBitmap, alwaysVisible) {
  const eventData = evt.detail;
  //const context = getNewContext(eventData.canvasContext.canvas);
  const context = getNewContext(eventData.canvas);

  const canvasTopLeft = math.coordinate.pixelToCanvas(eventData.element, {
    x: 0,
    y: 0
  });

  const canvasTopRight = math.coordinate.pixelToCanvas(eventData.element, {
    x: eventData.image.width,
    y: 0
  });

  const canvasBottomRight = math.coordinate.pixelToCanvas(eventData.element, {
    x: eventData.image.width,
    y: eventData.image.height
  });

  const CanvasWidth = math.point.distance(canvasTopLeft, canvasTopRight);
  const CanvasHeight = math.point.distance(canvasTopRight, canvasBottomRight);

  //const canvas = eventData.canvasContext.canvas;
  const canvas = eventData.canvas;
  const viewport = eventData.viewport;

  context.imageSmoothingEnabled = false;
  context.globalAlpha = getLayerAlpha(alwaysVisible);

  transformCanvasContext(context, canvas, viewport);

  const canvasViewportTranslation = {
    x: viewport.translation.x * viewport.scale,
    y: viewport.translation.y * viewport.scale
  };

  context.drawImage(
    imageBitmap,
    canvas.width / 2 - CanvasWidth / 2 + canvasViewportTranslation.x,
    canvas.height / 2 - CanvasHeight / 2 + canvasViewportTranslation.y,
    CanvasWidth,
    CanvasHeight
  );

  context.globalAlpha = 1.0;

  resetCanvasContextTransform(context);
}

function getLayerAlpha(alwaysVisible) {
  if (alwaysVisible) {
    return state.alpha;
  }

  return state.hiddenButActiveAlpha;
}
